//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapGetters } from 'vuex'
import { mapActions, mapGetters } from 'vuex'
import ProductImageWatermark from '~/components/ProductImageWatermark'
export default {
  name: 'ProductsCard',
  components: { ProductImageWatermark },
  filters: {
    shortDescription (value) {
      if (value && value.length > 60) {
        return value.substring(0, 60) + '...'
      } else {
        return value
      }
    }
  },
  props: {
    cart: {
      type: Boolean,
      default: false
    },
    ind: {
      type: Number,
      default: null
    },
    qty: {
      type: Number,
      default: null
    },
    productPage: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      timeOut: null,
      removeTimeOut: null
    }
  },
  computed: {
    ...mapGetters({
      checkProd: 'cart/checkProd',
      prodPrice: 'cart/prodPrice',
      findCatById: 'findCatById',
      getRealPrice: 'getRealPrice'
    }),
    selected () {
      return this.checkProd(this.product)
    }
  },
  beforeDestroy () {
    if (this.timeOut) {
      clearTimeout(this.timeOut)
      this.timeOut = null
    }
    if (this.removeTimeOut) {
      clearTimeout(this.removeTimeOut)
      this.removeTimeOut = null
    }
  },
  methods: {
    ...mapActions({
      updateCart: 'cart/updateCart',
      removeItemInCart: 'cart/removeItemInCart'
    }),
    goTo () {
      const prod = this.product
      const cate = prod.category != null ? prod.category.name : this.findCategory(prod.category_id)
      return { name: 'products-category-id-product', params: { idCat: prod.category_id, category: cate, id: prod.id, product: encodeURI(this.passURI(prod.name)) } }
    },
    addItem () {
      const order = {
        item: Object.assign({}, this.product),
        qty: 1,
        isAdd: true
      }
      this.updateCart(order)
      this.$store.commit('SHOW_Cart', true)
      this.$notify.show({
        text: 'Producto Agregado',
        type: 'success',
        closeWait: 2000
      })
    },
    removeItem () {
      if (this.removeTimeOut) {
        clearTimeout(this.removeTimeOut)
        this.removeTimeOut = null
      }
      const vm = this
      this.removeItemInCart({
        item: vm.product
      })
      if (this.$store.state.cart.cartItemList.length === 0) {
        this.$store.commit('HIDE_Cart')
      }
    },
    scheduleRemoveIfZero (qty) {
      if (!this.cart) { return }
      if (this.removeTimeOut) {
        clearTimeout(this.removeTimeOut)
        this.removeTimeOut = null
      }
      if (qty !== 0) { return }
      this.$notify.show({
        text: 'El producto se eliminará del carrito en 3 segundos',
        type: 'warning',
        closeWait: 2000
      })

      this.removeTimeOut = setTimeout(() => {
        const cartProd = this.checkProd(this.product)
        if (cartProd && Number(cartProd.qty) === 0) {
          this.removeItem()
        }
      }, 3000)
    },
    decreaseQty () {
      const currentQty = Number(this.product.qty || this.qty || 0)
      const nextQty = currentQty > 0 ? currentQty - 1 : 0
      this.$store.dispatch('cart/udpQty', { item: this.product, type: 0 })
      this.scheduleRemoveIfZero(nextQty)
    },
    increaseQty () {
      this.$store.dispatch('cart/udpQty', { item: this.product, type: 1 })
      this.scheduleRemoveIfZero(1)
    },
    updateQuantity (event) {
      if (this.timeOut) { clearTimeout(this.timeOut) }
      this.timeOut = setTimeout(() => {
        const vm = this
        const qty = Math.max(0, Number(event.target.value) || 0)
        this.updateCart({
          item: vm.product,
          qty,
          isAdd: false
        })
        this.scheduleRemoveIfZero(qty)
      }, 1200)
    },
    // delCartProd (ind) {
    //   this.$store.dispatch('removeItem', ind)
    //   if (this.$store.state.storeCart.length === 0) {
    //     this.$store.dispatch('showCart')
    //   }
    // },
    showProd (product) {
      this.$store.commit('SEL_ProdModal', product)
      this.$store.commit('SHOW_Modal', true)
    },
    findCategory (category) {
      const cate = this.findCatById(Number(category))
      return this.passURI(cate.name)
    },
    // findCategoryId (category) {
    //   for (let i = 0; i < this.$store.state.categories.length; i++) {
    //     if ((isNaN(category) ? this.passURI(this.$store.state.categories[i].name) : this.$store.state.categories[i].id) === category) {
    //       return i
    //     }
    //   }
    //   return -1
    // },
    passURI (uri) {
      return uri.toLowerCase().replace(/ /g, '-')
    }
  }
}
